__turbopack_context__.v({
  "card": "CatalogBookCard-module__ec6bAW__card",
  "cardBody": "CatalogBookCard-module__ec6bAW__cardBody",
  "cardImage": "CatalogBookCard-module__ec6bAW__cardImage",
  "cardTitle": "CatalogBookCard-module__ec6bAW__cardTitle",
});
